export default __webpack_public_path__ + "static/media/stuttgart.dd459a18.png";